import React, { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '../config/api';

export default function PositionsAdminPage(){
  const token = (typeof window!=='undefined') ? (localStorage.getItem('authToken')||'') : '';
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [newRole, setNewRole] = useState('manager');
  const [editItem, setEditItem] = useState(null); // {id,name,default_role}
  const roles = ['manager','assistant','gd','hr','tech'];

  const load = useCallback(()=>{
    setLoading(true); setError('');
    fetch(apiUrl('/api/positions'), { headers: token? { Authorization:`Bearer ${token}` } : {} })
      .then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=> { if(!ok) throw new Error(data?.error||'error'); setItems(Array.isArray(data)? data:[]); })
      .catch(e=> setError(e.message||String(e)))
      .finally(()=> setLoading(false));
  }, [token]);

  useEffect(()=>{ load(); }, [load]);

  function createPosition(){
    if(!newName.trim()) { alert('Название обязательно'); return; }
    setCreating(true);
    fetch(apiUrl('/api/positions'), { method:'POST', headers:{ 'Content-Type':'application/json', ...(token? { Authorization:`Bearer ${token}` }: {}) }, body: JSON.stringify({ name:newName.trim(), default_role:newRole }) })
      .then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=> { if(!ok){ alert(data?.error||'Ошибка'); return;} setNewName(''); setNewRole('manager'); load(); })
      .catch(()=> alert('Сбой сети'))
      .finally(()=> setCreating(false));
  }

  function startEdit(item){ setEditItem({ ...item }); }
  function cancelEdit(){ setEditItem(null); }
  function saveEdit(){
    if(!editItem) return;
    const { id, name, default_role } = editItem;
    if(!name.trim()) { alert('Название обязательно'); return; }
    fetch(apiUrl(`/api/positions/${id}`), { method:'PATCH', headers:{ 'Content-Type':'application/json', ...(token? { Authorization:`Bearer ${token}` }: {}) }, body: JSON.stringify({ name:name.trim(), default_role }) })
      .then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=> { if(!ok){ alert(data?.error||'Ошибка'); return;} setEditItem(null); load(); })
      .catch(()=> alert('Сбой сети'))
  }

  function remove(id){ if(!window.confirm('Удалить должность?')) return; fetch(apiUrl(`/api/positions/${id}`), { method:'DELETE', headers: token? { Authorization:`Bearer ${token}` }: {} })
      .then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=> { if(!ok){ alert(data?.error||'Ошибка'); return;} load(); })
      .catch(()=> alert('Сбой сети')) }

  return (
    <div style={{ padding:24, maxWidth:1100, margin:'0 auto' }}>
      <h2 style={{ marginTop:0 }}>Справочник должностей</h2>
      <p style={{ marginTop:4, color:'#555' }}>Управление доступно только суперпользователю. Роли: manager, assistant, gd, hr, tech.</p>
      {error && <div style={{ color:'#b91c1c', marginBottom:12 }}>Ошибка: {error}</div>}
      <div style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:12, padding:16, marginBottom:24 }}>
        <h3 style={{ marginTop:0, fontSize:18 }}>Добавить должность</h3>
        <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
          <input placeholder='Название должности' value={newName} onChange={e=> setNewName(e.target.value)} style={{ flex:'1 1 260px', padding:10 }} />
          <select value={newRole} onChange={e=> setNewRole(e.target.value)} style={{ padding:10 }}>
            {roles.map(r=> <option key={r} value={r}>{r}</option>)}
          </select>
          <button disabled={creating} onClick={createPosition} style={{ padding:'10px 18px', background:'#2563eb', color:'#fff', border:'1px solid #1d4ed8', borderRadius:8 }}>{creating? 'Создание…':'Добавить'}</button>
        </div>
      </div>

      <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:12, overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ background:'#f1f5f9' }}>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0', width:60 }}>ID</th>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0' }}>Название</th>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0', width:140 }}>Роль по умолч.</th>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0', width:160 }}>Создано</th>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0', width:160 }}>Обновлено</th>
              <th style={{ textAlign:'left', padding:10, borderBottom:'1px solid #e2e8f0', width:140 }}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={{ padding:20 }}>Загрузка…</td></tr>}
            {!loading && items.length===0 && <tr><td colSpan={6} style={{ padding:20 }}>Нет должностей</td></tr>}
            {items.map(it => {
              const editing = editItem && editItem.id===it.id;
              return (
                <tr key={it.id} style={{ borderTop:'1px solid #f1f5f9' }}>
                  <td style={{ padding:10 }}>{it.id}</td>
                  <td style={{ padding:10 }}>
                    {editing ? (
                      <input value={editItem.name} onChange={e=> setEditItem(s=>({ ...s, name:e.target.value }))} style={{ width:'100%', padding:8 }} />
                    ) : it.name }
                  </td>
                  <td style={{ padding:10 }}>
                    {editing ? (
                      <select value={editItem.default_role} onChange={e=> setEditItem(s=>({ ...s, default_role:e.target.value }))} style={{ width:'100%', padding:8 }}>
                        {roles.map(r=> <option key={r} value={r}>{r}</option>)}
                      </select>
                    ) : it.default_role }
                  </td>
                  <td style={{ padding:10, fontSize:12, color:'#555' }}>{it.createdAt}</td>
                  <td style={{ padding:10, fontSize:12, color:'#555' }}>{it.updatedAt}</td>
                  <td style={{ padding:10, display:'flex', gap:8 }}>
                    {!editing && <button onClick={()=> startEdit(it)} style={{ padding:'6px 10px' }}>Редакт.</button>}
                    {editing && <>
                      <button onClick={saveEdit} style={{ padding:'6px 10px', background:'#16a34a', color:'#fff', border:'1px solid #15803d' }}>Сохранить</button>
                      <button onClick={cancelEdit} style={{ padding:'6px 10px' }}>Отмена</button>
                    </>}
                    <button onClick={()=> remove(it.id)} style={{ padding:'6px 10px', background:'#dc2626', color:'#fff', border:'1px solid #b91c1c' }}>Удалить</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
